/* eslint-disable prettier/prettier */
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NewsContainer from "./News";
import NewsList from "./NewsList";
import TagsContainer from "./Tags";
import TagsList from "./TagsList";

const NewsRouter = () => {
  return (
    <Switch>
      <Route exact path="/news">
        <Redirect to="/news/news" />
      </Route>
      <Route exact path="/news/news">
        <NewsList />
      </Route>
      <Route exact path="/news/tags">
        <TagsList />
      </Route>
      <Route exact path="/news/tags/new">
        <TagsContainer />
      </Route>
      <Route exact path="/news/tags/:id">
        <TagsContainer />
      </Route>
      <Route path="/news/news/:id?/:tab?">
        <NewsContainer />
      </Route>
    </Switch>
  );
};

export default NewsRouter; 